export default __webpack_public_path__ + "static/framework-f9bf40456016b2b02bbb4ede652b2d83.png";